export const TKeyBlog = {
  BLOG_NAV_LABEL: "BLOG_NAV_LABEL",
  BLOG_MENU_LABEL: "BLOG_MENU_LABEL",
  BLOG_PAGE_TITLE: "BLOG_PAGE_TITLE",
  BLOG_PAGE_SUBTITLE: "BLOG_PAGE_SUBTITLE",
  BLOG_HERO_BADGE: "BLOG_HERO_BADGE",
  BLOG_HERO_TITLE_1: "BLOG_HERO_TITLE_1",
  BLOG_HERO_TITLE_2: "BLOG_HERO_TITLE_2",
  BLOG_HERO_TEXT: "BLOG_HERO_TEXT",
  BLOG_CAT_ALL: "BLOG_CAT_ALL",
  BLOG_READ_ARTICLE: "BLOG_READ_ARTICLE",
  BLOG_BACK_TO_BLOG: "BLOG_BACK_TO_BLOG",
  BLOG_TOC_TITLE: "BLOG_TOC_TITLE",
  BLOG_RELATED_TITLE: "BLOG_RELATED_TITLE",
  BLOG_FAQ_TITLE: "BLOG_FAQ_TITLE",
  BLOG_LIMIT_LABEL: "BLOG_LIMIT_LABEL",
  BLOG_UPDATED_ON: "BLOG_UPDATED_ON",
  BLOG_CTA_TITLE: "BLOG_CTA_TITLE",
  BLOG_CTA_TEXT: "BLOG_CTA_TEXT",
} as const;
